import s from './Footer.module.css';

export function Footer() {
  return (
    <div className={s.footer}>
      <span className={s.text}>
        Powered by{' '}
        <a
          href="https://onboardi.ai"
          target="_blank"
          rel="noopener noreferrer"
          className={s.link}
        >
          Onboardi.ai
        </a>
      </span>
    </div>
  );
}